import React from 'react'
import Category from '../../Components/tutor/Category'

function Categories() {
  return (
    <div>
      <Category/>
    </div>
  )
}

export default Categories
